import app from 'new-ui/app';
import { sendMessage as sendMessageToNbaChat } from 'new-ui/NBA/api';
import { isNaN } from 'lodash';
import { mergeUser } from 'modules/user/utils';
import { mergeUserProfiles } from 'modules/medicalFiles/api';
import { CHAT_ROLES } from './constants';

function addDateSinceUpdate(obj) {
  const today = new Date();
  const result = {};

  function calculateDaysSince(dateStr) {
    if (!dateStr) return null;
    try {
      const parts = dateStr.split('-');
      if (parts.length !== 3) return null;
      const [day, month, year] = parts.map(Number);
      if (isNaN(day) || isNaN(month) || isNaN(year) || month < 1 || month > 12 || day < 1 || day > 31) return null;

      const updateDate = new Date(year, month - 1, day);
      if (isNaN(updateDate.getTime())) return null;

      const diffInMs = today.getTime() - updateDate.getTime();
      const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
      return Math.max(0, diffInDays);
    } catch (error) {
      console.error(`Error calculating days since update for date "${dateStr}":`, error);
      return null;
    }
  }

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const entry = obj[key];
      const newEntry = entry && typeof entry === 'object' ? JSON.parse(JSON.stringify(entry)) : entry;

      // eslint-disable-next-line no-prototype-builtins
      if (newEntry?.hasOwnProperty('date_of_update')) {
        newEntry.days_since_update = calculateDaysSince(newEntry.date_of_update);
      }
      result[key] = newEntry;
    }
  }
  return result;
}

const MAX_SOC_TREATMENTS_TO_SEND = 15;

export const formmatedlDataForNba = (
  user,
  trials,
  userSponsoredTrials,
  socTreatmentsCategories,
) => {
  try {
    const baseData = window.structuredClone(user);
    const {
      temp_id: _pTempId,
      is_done: _pIsDone,
      answered_no_on_has_treatment_date: _pAnsweredNo,
      user_role: _pUserRole,
      trialsCountBeforeExtraFilter: _pTrialsCount,
      documents_data: _pDocsData,
      providerCode: _pProviderCode,
      providerConsent: _pProviderConsent,
      looking_for: _pLookingFor,
      ...restPersonal
    } = baseData.personal || {};
    const personalPayload = restPersonal;

    const { temp_id: _cpTempId, ...restConditionProfile } = baseData.condition_profile || {};
    const conditionProfilePayload = restConditionProfile;

    const { country, ...restInfo } = baseData.info || {};
    const infoPayload = {
      ...restInfo,
      Fulladdress: country?.label,
      addressLat: country?.location?.lat,
      addressLng: country?.location?.lng,
    };

    const userChangesWithDatesRaw = addDateSinceUpdate(app?.coniguration?.userConfiguration?.userChanges || {});
    const {
      'condition_profile.qstack': _ucQstack,
      'personal.reached_required_question': _ucReachedRequired,
      ...userChangesWithDatesPayload
    } = userChangesWithDatesRaw;

    const payload = {
      personal: personalPayload,
      condition_profile: conditionProfilePayload,
      info: infoPayload,
      socTreatments: app?.treatments?.slice(0, MAX_SOC_TREATMENTS_TO_SEND) ?? [],
      userNctList: trials ?? [],
      numberOfTrialList: trials?.length ?? 0,
      numberOfApprovedDrugs: app?.treatments?.length ?? 0,
      userSponsoredTrials,
      userHaveSponseredTrialList: !!userSponsoredTrials.length,
      socTreatmentsCategories: socTreatmentsCategories ?? [],
      DaysSinceRegister: app?.coniguration?.userConfiguration?.DaysSinceRegister ?? 0,
      userChangesWithDates: userChangesWithDatesPayload,
      userTreatments: app?.user?.condition_profile?.treatments ?? [],
    };

    return payload;
  } catch (error) {
    console.error('-- ~ formmatedlDataForNba ~ error:', error);
    return {};
  }
};

export const sendMessageToNba = async ({
  userWixId,
  userPrompt,
  payload,
  addMessages,
  actionIdentifier = null,
}) => {
  let response = {};
  try {
    const apiPayload = {
      userPrompt,
      userWixId,
      conditionProfile: payload.condition_profile,
      socTreatments: payload.socTreatments,
      userNctList: payload.userNctList,
      userChangesWithDates: payload.userChangesWithDates,
      ...(actionIdentifier && { actionIdentifier }),
      userLocation: app?.user?.info?.country,
    };
    response = await sendMessageToNbaChat(apiPayload);
    if (!response || !response.response) {
      throw new Error('Invalid response structure from NBA chat API');
    }

    const content = Array.isArray(response?.response?.messages) && response.response.messages.length > 0
      ? response.response.messages
      : `${response.response.responseText}`;

    addMessages([{ content, role: CHAT_ROLES.TINA }]);

    if (response.response.triggerUiUpdate && response.response.medicalConditionDelta) {
      const mergedUser = await mergeUserProfiles({
        oldProfile: app.user,
        newProfile: mergeUser(app.user, { condition_profile: response.response.medicalConditionDelta }),
      });

      await app.handleUserUpdate({ data: mergedUser });
    }
  } catch (error) {
    console.error('Error in handleSendMessageToNba:', error);
    addMessages([{ content: 'Sorry, I encountered an issue. Please try again later.', role: CHAT_ROLES.TINA }]);
  }

  return response;
};
